import React, {useState} from 'react';
import Banner from '../../../common/components/Banner';
import FaqParentAccordion from './components/FaqParentAccordion';
import FaqBeddingAccordion from './components/FaqBeddingAccordion';
import PropTypes from 'prop-types';
import {
  Tabs,
  Tab,
  Box
} from '@mui/material';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Faq() {

  const [switchTabValue, setSwitchTabValue] = useState(0);

  const switchHandleChange = (event, newValue) => {
    setSwitchTabValue(newValue);
  };

  return (
    <>
        <Banner type="small" imgId="faq-banner.jpg" />
        <div className='bs-section bs-section--typ-grey bs-section--typ-faq lyt-faq'>
            <div className='bs-section__section-head lyt-faq__head'>
                <h2 className='bs-section__title'>frequently asked questions</h2>
                <Tabs value={switchTabValue} onChange={switchHandleChange} aria-label="basic tabs example" className='bs-switch lyt-faq__tab-nav'>
                  <Tab 
                    label={<div className="bs-switch__option">fabric</div>}
                    {...a11yProps(0)} 
                  />
                  <Tab 
                    label={<div className="bs-switch__option">bedding</div>}
                    {...a11yProps(1)} 
                  />
                </Tabs>
            </div>
            <div className='bs-section__section-cont lyt-faq__tab-count'>
              <CustomTabPanel value={switchTabValue} index={0}>
                <FaqParentAccordion/>
              </CustomTabPanel>
              <CustomTabPanel value={switchTabValue} index={1}>
                <FaqBeddingAccordion/>
              </CustomTabPanel>
            </div>
        </div>
    </>
    
  )
}

export default Faq